import {compose, createStore, applyMiddleware} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import {save, load} from 'redux-localstorage-simple'
import {createLogicMiddleware} from 'redux-logic';

import {key as authKey} from './auth';
import {key as autoLogoutKey} from './autoLogout';

import settings from 'Root/settings.json';

import logic from './rootLogic';
import rootReducer from './rootReducer';
import * as helper from 'App/util/common/helper';

// redux-logic
const deps = {
  // optional injected dependencies for logic
};
const logicMiddleware = createLogicMiddleware(logic, deps);

// config persistent storage (localStorage)
const config = {
  states: [authKey, autoLogoutKey],
  namespace: settings.storage_name,
  debounce: 0
};

// merge middlewares
const middleware = applyMiddleware(
  logicMiddleware,
  // save to localStorage
  save(
    config
  )
);

const composeEnhancers = helper.DEV_MODE ? composeWithDevTools : compose;

// setup redux
const enhancer = composeEnhancers(
  middleware
);

const store = createStore(
  rootReducer,
  // load from localStorage
  load(config),
  enhancer
);
export default store;


// WEBPACK FOOTER //
// ./src/util/redux/store.js